export const BUSINESS_NAME = "Just Call Paul — Home & Property Services";
export const PHONE_DISPLAY = "352-570-8487";
export const PHONE_TEL = "+13525708487";
export const EMAIL = "justcallpaul352@gmail.com";
export const FACEBOOK_URL = "https://www.facebook.com/justcallpaul352";
export const PAUL_PHOTO = "/paul.webp";
export const GOOGLE_REVIEW_URL = "https://g.page/r/CZ7seHJE8xpQEBM/review";

export const SERVICE_AREA_SUMMARY = "Citrus County, Hernando County & The Villages Area";

export const AREA_GROUPS = [
  {
    region: "Citrus County",
    areas: ["Inverness", "Floral City", "Crystal River", "Homosassa", "Lecanto", "Beverly Hills", "Hernando", "Citrus Springs"],
    note: "Home base — Paul lives and works right here in Citrus County.",
  },
  {
    region: "Hernando County",
    areas: ["Spring Hill", "Brooksville"],
    note: "Paul previously operated successful home-service businesses in Spring Hill & Brooksville.",
  },
  {
    region: "The Villages Area",
    areas: ["The Villages", "Wildwood"],
    note: "Serving The Villages, Wildwood & nearby communities.",
  },
];

export const AREAS = AREA_GROUPS.flatMap((g) => g.areas);

export const IMAGES = {
  pressureWashing:
    "https://images.unsplash.com/photo-1605146768851-eda79da39897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzF8MHwxfHNlYXJjaHwxfHxwcmVzc3VyZSUyMHdhc2hpbmclMjBob3VzZSUyMGRyaXZld2F5JTIwZXh0ZXJpb3IlMjBjbGVhbmluZ3xlbnwwfHx8fDE3OTE1NTE3MjB8MA&ixlib=rb-4.1.0&auto=format&q=75&w=900",
  driveway:
    "https://images.unsplash.com/photo-1781637202423-33ec5b47e52e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzF8MHwxfHNlYXJjaHw0fHxwcmVzc3VyZSUyMHdhc2hpbmclMjBob3VzZSUyMGRyaXZld2F5JTIwZXh0ZXJpb3IlMjBjbGVhbmluZ3xlbnwwfHx8fDE3OTE1NTE3MjB8MA&ixlib=rb-4.1.0&auto=format&q=75&w=900",
  tools:
    "https://images.unsplash.com/photo-1606676539940-12768ce0e762?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxob21lJTIwcmVwYWlyJTIwaGFuZHltYW4lMjBwYWludGVyJTIwZmxvb3JpbmclMjBpbnN0YWxsYXRpb258ZW58MHx8fHwxNzkxNTUxNzIwfDA&ixlib=rb-4.1.0&auto=format&q=75&w=900",
  painting:
    "https://images.unsplash.com/photo-1599619585752-c3edb42a414c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxob21lJTIwcmVwYWlyJTIwaGFuZHltYW4lMjBwYWludGVyJTIwZmxvb3JpbmclMjBpbnN0YWxsYXRpb258ZW58MHx8fHwxNzkxNTUxNzIwfDA&ixlib=rb-4.1.0&auto=format&q=75&w=900",
  flooring:
    "https://images.unsplash.com/photo-1595814433015-e6f5ce69614e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxob21lJTIwcmVwYWlyJTIwaGFuZHltYW4lMjBwYWludGVyJTIwZmxvb3JpbmclMjBpbnN0YWxsYXRpb258ZW58MHx8fHwxNzkxNTUxNzIwfDA&ixlib=rb-4.1.0&auto=format&q=75&w=900",
  flag:
    "https://images.unsplash.com/photo-1588111817213-1a12f73fbf20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzF8MHwxfHNlYXJjaHwyfHxwcmVzc3VyZSUyMHdhc2hpbmclMjBob3VzZSUyMGRyaXZld2F5JTIwZXh0ZXJpb3IlMjBjbGVhbmluZ3xlbnwwfHx8fDE3OTE1NTE3MjB8MA&ixlib=rb-4.1.0&auto=format&q=75&w=900",
};

export const CATEGORY_META = {
  "Exterior Cleaning": { image: IMAGES.pressureWashing, tagline: "Pressure washing, soft washing & every exterior surface" },
  "Home Improvements": { image: IMAGES.painting, tagline: "Painting, flooring & upgrades that transform your home" },
  "Handyman & Property Services": { image: IMAGES.tools, tagline: "Repairs, maintenance & the whole honey-do list" },
};

export const money = (v) => `$${Math.round(v).toLocaleString("en-US")}`;
